import { Action } from "../../../common/actions/core/action";

export class NoAuthOpenDistantSalesAggreementAction implements Action {
  constructor(
    public msisdn: string,
    public onApprove: () => void,
    public saleType: string,
    public offerId?: string,
    public paymentType?: string
  ) {}
}



// WEBPACK FOOTER //
// src/app/no-auth/components/distant-sales-dialog/distant-sales-dialog.action.ts